import { render, staticRenderFns } from "./GridSolicitudesCambio.vue?vue&type=template&id=13821966&"
import script from "./GridSolicitudesCambio.vue?vue&type=script&lang=js&"
export * from "./GridSolicitudesCambio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports